import { useContext, useRef, useState, useEffect } from "react";
import { NavLink, Outlet, useLocation, useNavigate } from "react-router-dom";


const FAQ = () => {
  const location = useLocation();
  const navigate = useNavigate();
  useEffect(() => {
    if (location.pathname === "/faq") {
      navigate("/faq/buying-a-car", { replace: true });
    }
  }, [location.pathname, navigate]);
  

  

  return (
    <section className="">
      <div className="container pt-5  mt-4 mt-lg- mt-xl-5">
        <div className="row pt-sm-2 pt-lg-0"  style={{ marginLeft: "-40px"  }}>
          <aside className="col-lg-3" style={{ marginTop: "-200px"  }}>
            <div
              className="offcanvas-lg offcanvas-start sticky-lg-top pe-lg-3 pe-xl-4"
              id="accountSidebar"
            >
              <div className="d-none d-lg-block" style={{ height: "105px" }}></div>

              {/* Header */}
              <div className="offcanvas-header d-lg-block py-3 p-lg-0">
                <div className="d-flex flex-row flex-lg-column align-items-center align-items-lg-start">

                  <div className="pt-lg-3 ps-3 ps-lg-0">
                    <h6 className="mb-1"></h6>
                    <p className="fs-sm mb-0"></p>
                  </div>
                </div>

                <button
                  type="button"
                  className="btn-close d-lg-none"
                  data-bs-dismiss="offcanvas"
                  data-bs-target="#accountSidebar"
                  aria-label="Close"
                ></button>
              </div>

              {/* Sidebar nav */}
              <div className="offcanvas-body d-block pt-2 pt-lg-4 pb-lg-0 mb-5">
              <h3 className="fs-base opacity-75 me-2" style={{ marginLeft: "0px" }}>Buyer Queries</h3>
                <nav className="list-group list-group-borderless">
                  <NavLink
                    to="/faq/buying-a-car"
                    className="list-group-item list-group-item-action d-flex align-items-center"
                    style={{ marginLeft: "10px",marginTop:"-10px" }}
                  >
                    <i className="fs-base opacity-75 me-2"></i>
                    Buying a Car
                  </NavLink>
                 
                </nav>
                <h3 className="fs-base opacity-75 me-2" style={{ marginLeft: "0px" }}>Seller Queries</h3>
              
                <nav className="list-group list-group-borderless">
                  <NavLink
                    to="/faq/selling-a-car"
                    className="list-group-item list-group-item-action d-flex align-items-center"
                    style={{ marginLeft: "10px",marginTop:"-10px" }}
                  >
                    <i className="fs-base opacity-75 me-2"></i>
                    Selling a Car
                  </NavLink>
                </nav>

                  <h3 className="fs-base opacity-75 me-2" style={{ marginLeft: "0px" }}>Payments</h3>
              
               <nav className="list-group list-group-borderless">
                  <NavLink
                    to="/faq/how-it-works"
                    className="list-group-item list-group-item-action d-flex align-items-center"
                    style={{ marginLeft: "10px" ,marginTop:"-10px"}}
                  >
                  <i className="fs-base opacity-75 me-2"></i>
                 How it Works?
                </NavLink>
                </nav>
                <nav className="list-group list-group-borderless">
                  <NavLink
                    to="/faq/ownership-transfer"
                    className="list-group-item list-group-item-action d-flex align-items-center"
                    style={{ marginLeft: "10px" ,marginTop:"-10px"}}
                  >
                  <i className="fs-base opacity-75 me-2"></i>
                  Transfer & Ownership
                </NavLink>
                </nav>
                <nav className="list-group list-group-borderless">
                  <NavLink
                    to="/faq/fees-and-charges"
                    className="list-group-item list-group-item-action d-flex align-items-center"
                    style={{ marginLeft: "10px" ,marginTop:"-10px"}}
                  >
                  <i className="fs-base opacity-75 me-2"></i>
                  Fees & Charges
                </NavLink>
                </nav>
              </div>
            </div>
          </aside>

          <div className="col-lg-9">
            <Outlet />
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
